import cn from 'clsx'
import { Avatar } from '@/components/avatar/avatar'
import { Box } from '@/components/Box/Box'
import { BlockQuote } from '@/components/Text/BlockQuote'

import { Text } from '@/components/Text/Text'

import css from './quote.module.css'

export default {
    title: 'Others/Quote',
    component: Quote,
}

export type QuoteProps = {
    author: string
    quoteText: string
    role?: string
    avatarSrc?: string
    className?: string
}

function Quote({ author, role, quoteText, avatarSrc, className }: QuoteProps) {
    return (
        <Box className={cn(css.quoteContainer, className)}>
            <BlockQuote size="quote-lg">{quoteText}</BlockQuote>
            <Box className={css.citation}>
                {avatarSrc ? (
                    <Avatar src={avatarSrc} alt={author} size={{ xs: 56, sm: 52 }} />
                ) : null}
                <Box className={css.author}>
                    <Text className={css.name} size="minor-lg">
                        {author}
                    </Text>
                    {role ? (
                        <Text className={css.role} size="body-xs">
                            {role}
                        </Text>
                    ) : null}
                </Box>
            </Box>
        </Box>
    )
}

export { Quote }
